import { render, staticRenderFns } from "./my-slider.vue?vue&type=template&id=5530245a&scoped=true&"
import script from "./my-slider.vue?vue&type=script&lang=js&"
export * from "./my-slider.vue?vue&type=script&lang=js&"
import style0 from "./my-slider.vue?vue&type=style&index=0&id=5530245a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530245a",
  null
  
)

export default component.exports